import React from 'react';
import {
   Filter, TextInput,
} from 'react-admin';

const PackagesFilter = (props) => (
   <Filter {...props}>
      <TextInput label="Package name or url" source="url,name" alwaysOn />
   </Filter>
);

export default PackagesFilter;
